module.exports = global["$"] = require("-!C:\\Plentymarkets\\26628\\44\\Ceres\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");